module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAJCAYAAAARml2dAAAAZElEQVQImV3MoQ3CQBxG8V8vlw7QFXB0AILFIHCMVsMQJIjm0MhOUMkIqC6AuUua/yffy/e6UoqwjCkHOOCJy14cMeMAqcIblgZbb8QL/b6ZsOKOLQp444xvFOrzhE8U8MMVjz8w0g5XNGf/xgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/pp1.png
// module id = cj+C
// module chunks = 22